import React,{useEffect} from "react";
import { useLocation,BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Chat from "./Components/Chatbox/Chat"
import Home from "./Components/Home/Home";  
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import About from "./Components/About/About";
import Flight from "./Components/Flight/Flight";
import Destination from "./Components/Destination/Destination";
import DestinationDetails from "./Components/DestinationOffer/DestinationDetails";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "./Components/PrivacyAndPolicy/PrivacyAndPolicy";
import Backtotop from "./Components/Backtotop/Backtotop"
import FlightDetails from "./Components/Flight/FlightDetails";
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/flight" element={<Flight />} />
        <Route path="/flight/:id" element={<FlightDetails />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacyandpolicy" element={<PrivacyPolicy />} />
        <Route path="/holidays" element={<Destination />} />
        <Route path="/holidays/:id" element={<DestinationDetails />} />
      </Routes>
      <Backtotop/>
      <Chat/>
      <Footer/>
    </Router>
  );
}

export default App;
